const showHidePartners = (partners, startElement, pageSize) => {
    partners.forEach((partner, index) => {
        if (index >= startElement && index < (startElement + pageSize)) {
            partner.style.display = '';
        } else {
            partner.style.display = 'none';
        }
    })
}

document.querySelectorAll('.partner-container').forEach((item) => {
    const pagination = item.querySelector('scale-pagination');
    
    if (!pagination) return false;
    
    const pageSize = Math.abs(pagination.getAttribute('page-size'));
    const partners = item.querySelectorAll('.partners .partner');
    const initialStartElement = pagination.startElement;

    showHidePartners(partners, initialStartElement, pageSize);

    pagination.addEventListener('scale-pagination', evt => {
        const startElement = evt.detail.startElement;

        showHidePartners(partners, startElement, pageSize);
        item.scrollIntoView()
    })
})
